<template>
  <b-modal
    v-model="showModal"
    centered
    size="lg"
    header-class="custom-modal-header"
    hide-footer
  >
    <template #modal-header>
      <div class="d-flex justify-content-between align-items-center w-100">
        <p>USER LIST</p>
        <div class="d-flex w-75">
          <b-input-group class="w-100 mr-2">
            <b-form-input
              v-model="filter.search"
              placeholder="Search Name, Staff ID, Team, Employee ID, Email"
              @keydown.enter="handleSearch"
            />
            <b-input-group-append>
              <b-button @click="handleSearch" class="search-button">
                <font-awesome-icon icon="search" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <button
            type="button"
            aria-label="Close"
            class="btn p-0"
            @click="onCloseModal"
          >
            <font-awesome-icon icon="times" title="Delete" />
          </button>
        </div>
      </div>
    </template>
    <b-table
      responsive
      striped
      hover
      class="table-list"
      :items="items"
      :fields="fields"
      :busy="isBusy"
      show-empty
      :empty-text="$t('noData')"
    >
      <template v-slot:table-busy>
        <div class="text-center text-black my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
      </template>
      <template v-slot:cell(id)="data">
        <div class="d-flex justify-content-center">
          <button
            type="button"
            @click="onSubmit(data.item)"
            :disabled="isDisabled"
            class="btn btn-main"
          >
            Select
          </button>
        </div>
      </template>
      <template v-slot:cell(roleId)="data">
        <div class="d-flex justify-content-center">
          <span class="text-center">{{ formatRole(data.item.roleId) }} </span>
        </div>
      </template>
    </b-table>
    <b-row class="no-gutters px-3 px-sm-0">
      <b-col class="form-inline justify-content-end justify-content-sm-end">
        <div class="d-sm-flex">
          <b-pagination
            v-model="filter.pageNo"
            :total-rows="rows"
            :per-page="filter.perPage"
            class="m-md-0"
            @change="pagination"
            align="center"
          ></b-pagination>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import InputText from "@/components/inputs/InputText";

export default {
  name: "ModalForm",
  components: {
    InputText,
  },
  props: {
    path: {
      required: true,
      type: String,
    },
    roleId: {
      required: true,
      type: [String, Number],
    },
    roleMappingId: {
      required: true,
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      showModal: false,
      isDisabled: false,
      rows: 0,
      filter: {
        search: "",
        pageNo: 1,
        perPage: 5,
        active: true,
      },
      fields: [
        {
          key: "id",
          label: "",
          class: "w-action",
        },
        {
          key: "username",
          label: "Username",
          class: "w-100px",
          tdClass: "text-center",
        },
        {
          key: "firstname",
          label: "First Name",
          class: "w-100px",
          tdClass: "text-center",
        },
        {
          key: "lastname",
          label: "Last Lame",
          class: "w-100px",
          tdClass: "text-center",
        },
        {
          key: "roleId",
          label: "Role",
          class: "w-100px",
          tdClass: "text-center",
        },
      ],
      isBusy: false,
      items: [],
      form: {
        externalId: "",
        roleMappingId: "",
      },
    };
  },
  methods: {
    onShowModal: async function () {
      this.filter.roleId = this.roleId;
      this.filter.pageNo = 1;
      await this.getListUser();
      this.showModal = true;
    },
    handleSearch() {
      this.pagination(1);
    },
    onCloseModal() {
      this.clearFilter();
      this.showModal = false;
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getListUser();
    },
    clearFilter() {
      this.filter = {
        search: "",
        pageNo: 1,
        perPage: 5,
        active: true,
      };
    },
    formatRole(id) {
      switch (id) {
        case null:
          return "-";
        case 2:
          return "Agent";
        case 3:
          return "Super Admin";
        case 4:
          return "Team Admin";
      }
    },
    getListUser: async function () {
      await this.axios
        .post(`${this.$baseUrl}/user/List`, this.filter)
        .then((data) => {
          if (data.result == 1) {
            this.items = data.detail.userList;
            this.rows = data.detail.count;
          }
        });
    },
    onSubmit: async function (item) {
      this.isDisabled = true;
      this.form.externalId = item.userGUID;
      this.form.roleMappingId = this.roleMappingId;
      await this.axios
        .post(`${this.$baseUrl}/${this.path}`, this.form)
        .then((data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
            this.$emit("reloadData");
          } else
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });

      setTimeout(() => {
        this.isDisabled = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-main {
  min-width: 0 !important;
}
</style>
